module.exports = __webpack_public_path__ + "img/bs.559385a8.svg";